import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#607D8B',
        secondary: '#8B6E60',
        accent: '#0288D1', // light-blue darken-2
        success: '#388E3C' // green darken-2
      }
    }
  }
});
